import { ProfileOutlined } from "@ant-design/icons";
import React from "react";
import styled from "styled-components";

const Title = styled.div`
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  padding: 20px 0px 5px 5px;
`;

const ProgramTitle = ({ children }) => {
  return (
    <Title>
      <ProfileOutlined /> {children}
    </Title>
  );
};
export default ProgramTitle;
